import React from 'react';
const links = ['Allgemeine Geschäftsbedingungen', 'Datenschutzerklärung', 'Kontakt'];
export function Footer() {
  return <footer className="border-t border-ink-700 bg-ink-950 px-4 pb-28 pt-10 text-center sm:px-6" data-id="element-114" data-mp="3gg0za3iktxxn">
      <p className="font-display text-lg uppercase tracking-wide text-white" data-id="element-115" data-mp="32p5m4f11ouo9">
        Meister-Schweisssystem<span className="align-super text-[10px]" data-id="element-116" data-mp="36q93x72nl0s4">™</span>
      </p>

      <nav aria-label="Rechtliches" data-id="element-117" data-mp="3ueiltxwqx4dz">
        <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm text-white/60" data-id="element-118" data-mp="3ufju5umdncs0">
          {links.map(link => <li key={link} data-id="element-119" data-mp="3lem127dh8po7">
              <a href="#" className="transition-colors duration-150 ease-out hover:text-brand focus-visible:text-brand" data-id="element-120" data-mp="3ldamrdmenziu">
                {link}
              </a>
            </li>)}
        </ul>
      </nav>

      <p className="mt-5 text-xs text-white/40" data-id="element-121" data-mp="2eya1q2yx51r1">
        © 2026 MEISTER-SCHWEISSSYSTEM™ — Alle Rechte vorbehalten.
      </p>
    </footer>;
}